import BasicSearchRow from './BasicSearchRow';

export default BasicSearchRow;



// WEBPACK FOOTER //
// ./src/components/BasicSearchRow/index.js